<script>
import lazyLoadComponent from '@router/lazyload-component'
// import BaseButtonDialog from '@components/BaseButtonDialog'
import { debounce } from 'lodash'

import {
  genderFilter,
  orderStatusMap,
  orderStatusFilter,
  bookingStatusMap,
  bookingStatusFilter,
  orderPaymentMethodMap,
  orderPaymentMethodFilter,
  orderSourceMap,
  orderSourceFilter,
  paymentStatusMapFilter,
} from '@utils/filter-value-to-text'
import formatDate, { formatRequestData } from '@utils/format-date'

import pageMixin from '@src/mixins/pagination'
// import fetchListMixin from '@src/mixins/fetchList'



export default {
  page: {
    title: '訂單查詢',
    meta: [{ name: 'description', content: 'Order List' }],
  },
  components: {
    // BaseButtonDialog,
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
    DepositOrderForm: () => import('@components/Orders/DepositOrderForm'),
    DepositOrderDetail: () => import('@components/Orders/DepositOrderDetail'),
  },
  filters: {
    genderFilter,
    orderStatusFilter,
    bookingStatusFilter,
    orderPaymentMethodFilter,
    orderSourceFilter,
    formatDate,
    paymentStatusMapFilter,
  },
  mixins: [pageMixin],
  data() {
    return {
      orderStatusMap,
      componentKey: 0,
      drawerVisible: false,
      createOrderVisible: false,
      editOrderVisible: false,
      drawerOrderData: '',
      getRowKeys(row) {
        return row.id
      },
      expandRowKeys: [],
      filterData: {
        status: '',
        memberId: '',
        paymentMethod: 'All',
        dateType: 'create', // create 訂單成立日期、 use 訂單使用日期
        startDate: '',
        endDate: '',
      },
      statusList: { ...bookingStatusMap },
      sourceList: Object.freeze(orderSourceMap),
      paymentMethodList: Object.freeze(this.reduceMethod({ ...orderPaymentMethodMap })),
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一週',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一個月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三個月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      loadedOrders: [],
      queryProductName: '',
      tryingToGetOrder: false,
      tryingToExport: false,
      submitForm: [],
      submitRules: {
        title: [{ required: true, message: 'empty', trigger: 'change' }],
      },
      productList: [],
      isFilterChange: false,
      appStyle: process.env.VUE_APP_BUILD_MODE === 'admin-app-build'
    }
  },
  computed: {
    statusListFilter() {
      let obj = { ...orderStatusMap }
      delete obj['3']
      delete obj['4']
      delete obj['5']
      delete obj['6']
      return obj
    },
    filterDateRange: {
      get() {
        return [this.filterData.startDate, this.filterData.endDate]
      },
      set(value) {
        const [start, end] = value || ['', '']
        this.filterData.startDate = start
        this.filterData.endDate = end
      },
    },
    fetchDataParams() {
      const routeQuery = this.$route.query
      const queryData = Object.assign(routeQuery, this.pageQuery)
      const { startDate, endDate, dateType, ...filterDataWithoutDate } = this.filterData
      const searchWithDate = startDate && endDate
      const searchParams = searchWithDate
        ? Object.assign(this.filterData, {
          startDate: formatRequestData(startDate),
          endDate: formatRequestData(endDate),
        })
        : filterDataWithoutDate
      return Object.assign(searchParams, queryData)
    },
  },
  watch: {
    currentPage: {
      handler: 'tryToFetchList',
      immediate: true,
    },
    filterData: {
      handler() {
        this.isFilterChange = true
      },
      deep: true,
    },
    editOrderVisible(value) {
      if (!value) {
        if (this.$route.query.type === 'depositOrder') {
          this.$router.push({
            name: 'orders',
            params: {
              activeTabName: 'deposit',
            },
            query: {
            },
          })
        }
      }
    }
  },
  created() {
    this.tryToSearchProduct()
    if (this.$route.query.type === 'depositOrder') {
      this.tryToGetOrder(this.$route.query.id)
    }
  },
  mounted() {
    if (this.$route.params.activeTabName === 'deposit' && this.$route.params.from === 'checkInList') {
      this.$route.params.from = ''
      this.openDepositOrder()
    }
  },
  methods: {
    reduceMethod(list) {
      delete list.Deposit
      delete list.Prepaid
      if (!this.$cashFlowSettingPass()) {
        delete list.Vacc
        delete list.Credit
      }
      return { ...list }
    },
    async handleExport() {
      if (this.tryingToExport) return
      this.tryingToExport = true
      const { fileName, csvData } = await this.$store.dispatch('deposit/export', this.fetchDataParams)
      const csvFormatData = csvData.map((row) => Object.values(row).join(',')).join('\n')

      const blob = new Blob(['\uFEFF', csvFormatData], {
        type: 'text/csv;charset=utf-8;',
      })

      const url = window.URL.createObjectURL(blob)

      const tempLink = document.createElement('a')
      tempLink.download = fileName
      tempLink.href = url
      tempLink.click()
      window.URL.revokeObjectURL(url)
      this.tryingToExport = false
    },
    tableRowClassName({ row }) {
      const rowStatus = row.status
      const usedStatus = row.groupSize / row.usedSize
      if (rowStatus === 0) return 'order--canceled'
      if (usedStatus === 1) return 'order--used'
      if (row.id === this.expandRowKeys[0]) return 'expandedRow'
    },
    /**
     * @description 編輯時取得抽屜的資料
     */
    async tryToGetOrder(orderId) {
      try {
        this.tryingToGetOrder = true
        this.drawerOrderData = await this.$store.dispatch('deposit/fetchSingleOrder', orderId)
        await this.getContainerInfo()
        this.editOrderVisible = true
      } catch {
        // this.drawerVisible = false
      } finally {
        this.tryingToGetOrder = false
      }
    },
    /**
     * @description 更新drawer內資料
     */
    async updateDrawerData(orderId, cb) {
      this.drawerOrderData = await this.$store.dispatch('deposit/fetchSingleOrder', orderId)
      await this.getContainerInfo()
      cb()
    },
    /**
     * @description 取得container 資料
     */
    async getContainerInfo() {
      try {
        if (Object.keys(this.drawerOrderData).length > 0 && this.drawerOrderData.orderContainerUuid) {
          const containerInfo = await this.$store.dispatch('order/fetchContainerList', this.drawerOrderData.orderContainerUuid)
          this.$set(this.drawerOrderData, 'invoice', containerInfo.invoice)
          this.$set(this.drawerOrderData, 'containerInfo', containerInfo)
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    async tryToFetchListFilter() {
      // 當篩選前不在第一頁的時候，跳回第一頁
      if (this.currentPage !== 1) {
        this.currentPage = 1
        return
      }
      const { items, productName, total } = await this.$store.dispatch('deposit/fetchOrderList', this.fetchDataParams)
      this.loadedOrders = items
      this.queryProductName = productName
      this.$nextTick(() => {
        this.$refs.pagination && this.$refs.pagination.updateTotal(total)
      })
    },
    async tryToFetchList() {
      const { items, total } = await this.$store.dispatch('deposit/fetchOrderList', this.fetchDataParams)
      this.loadedOrders = items
      this.$nextTick(() => {
        this.$refs.pagination && this.$refs.pagination.updateTotal(total)
      })
    },
    clearSearchQuery() {
      this.$router.push(this.$route.path)
    },
    async tryToSearchProduct() {
      const { items } = await this.$store.dispatch('product/fetchList', { limit: 10000, page: 1, paginate: 0 })
      this.productList = items
    },
    onCellClick(row, column, cell) {
      if (column.type === 'expand') return
      this.tryToGetOrder(row.id)
    },
    excludeCanceledPrice(order) {
      let total = order.allTotal
      if (order.addOrders.length) {
        total = order.addOrders
          .map((subOrder) => subOrder.items)
          .flat()
          .reduce((acc, item) => (item.status === 0 ? acc + item.price : acc), total)
      }
      return total
    },
    handleExpand(row) {
      if (this.expandRowKeys[0] === row.id) {
        this.expandRowKeys = []
      } else {
        this.expandRowKeys = [row.id]
      }
    },
    sortChange({ column, prop, order }) {
      if (order) {
        this.filterData.order_by = prop
        this.filterData.order = order === 'ascending' ? 'asc' : 'desc'
        // this.filterData.page=1
        this.currentPage = 1
        this.tryToFetchList()
      }
    },
    tryToSearchByInput: debounce(function () {
      this.tryToFetchListFilter()
    }, 300),
    openDepositOrder() {
      this.createOrderVisible = true
    },
    onCreateOrderDone() {
      this.$refs.orderForm.closeDrawer()
      this.tryToFetchList()
    },
    async onEditOrderDone() {
      await this.tryToFetchList()
    },
    /**
     * @description 關閉編輯抽屜
     */
    async closeEditDrawer() {
      this.editOrderVisible = false
      await this.tryToFetchListFilter()
    },
  },
}
</script>

<template>
  <div>
    <div :class="$style.btnTop" class="btn-top-space-between">
      <div class="side search">
        <el-input v-model.trim.lazy="filterData.search" clearable placeholder="輸入使用人姓名、手機號碼或訂單編號"
          @input="tryToSearchByInput">
          <BaseIcon slot="suffix" name="search" class="el-input__icon" />
        </el-input>
      </div>
      <div class="side btn ml-md-3">
        <el-button class="is-round" plain @click="handleExport">
          <BaseIcon name="file-export" /> 訂單匯出
        </el-button>
        <el-button class="is-round" type="primary" @click="openDepositOrder">
          <BaseIcon name="plus" /> 代客儲值
        </el-button>
      </div>
    </div>
    <BaseTableSearch v-slot="{ fields }" class="isForTab" hide-action :default-value.sync="filterData"
      :class="$style.filter" @handleExport="handleExport" @reset="tryToFetchList" @tryToFetchList="tryToFetchListFilter">
      <el-form-item prop="status" style="width: 19%">
        <el-select v-model="fields.status" placeholder="選擇訂單狀態" @change="tryToFetchListFilter">
          <el-option value>所有訂單狀態</el-option>
          <el-option v-for="(status, statusValue) in statusListFilter" :key="statusValue" :label="status.text"
            :value="statusValue"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="paymentMethod" style="width: 19%">
        <el-select v-model="fields.paymentMethod" placeholder="選擇付款方式" @change="tryToFetchListFilter">
          <el-option label="所有付款方式" value="All"></el-option>
          <el-option v-for="(label, value) in paymentMethodList" :key="value" :label="label" :value="value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="width: 50%">
        <el-date-picker v-model="filterDateRange" type="daterange" align="right" unlink-panels range-separator="-"
          start-placeholder="起始日期" end-placeholder="結束日期" :picker-options="pickerOptions"
          @change="tryToFetchListFilter"></el-date-picker>
      </el-form-item>
    </BaseTableSearch>
    <div class="isStylePageContent">
      <div class="el-table-wrapper">
        <el-table v-loading.fullscreen.lock="tryingToGetOrder" element-loading-text="取得訂單資訊中" :data="loadedOrders"
          :default-sort="{ prop: 'created', order: 'descending' }" :row-key="getRowKeys"
          :row-class-name="tableRowClassName" :expand-row-keys="expandRowKeys" @cell-click="onCellClick"
          @expand-change="handleExpand" @sort-change="sortChange">

          <el-table-column v-slot="{ row }" label="訂單編號" prop="created_at" min-width="150" sortable>
            <div class="Jost fs-sm fw-medium">{{ `#${row.orderContainerDisplayId}` }}</div>
            <div class="fs-2sm text-secondary-light">{{ row.created | formatDate('dateTime') }}</div>
          </el-table-column>
          <el-table-column v-slot="{ row }" label="狀態" prop="paymentMethod" min-width="100">
            <template v-if="row.status === 0">
              <BaseStateLabel state="secondary" text>{{ row.status | bookingStatusFilter('text') }}</BaseStateLabel>
            </template>
            <template v-else>
              <BaseStateLabel :state="row.paymentStatus | paymentStatusMapFilter('color')" text>{{ row.paymentStatus |
                paymentStatusMapFilter('text') }}</BaseStateLabel>
              <br />
              <BaseStateLabel state="secondary" text class="fs-2sm">{{ row.source | orderSourceFilter }}</BaseStateLabel>
            </template>
          </el-table-column>
          <el-table-column v-slot="{ row }" label="付款方式" min-width="140">
            <BaseStateLabel state="secondary" text>
              <span v-if="row.paymentMethod !== null">{{ row.paymentMethod | orderPaymentMethodFilter }}</span>
              <span v-else>不指定</span>
            </BaseStateLabel>
            <br />
            <span v-if="row.invoiceNumber">{{ row.invoiceNumber }}</span>
          </el-table-column>
          <el-table-column v-slot="{ row }" min-width="150" label="客戶資訊">
            <div>{{ row.fullName }} {{ row.gender | genderFilter }}</div>
            <div class="fs-2sm  text-secondary-light">{{ `${row.phoneCode} ${row.phoneNumber}` }}</div>
          </el-table-column>
          <el-table-column v-slot="{ row }" min-width="140" label="儲值金方案名稱">
            <div>
              <b> {{ row.params[0].title }}</b><br>
              <span class="fs-2sm  text-secondary-light">儲值金:{{ row.point }}點</span>
            </div>
          </el-table-column>
          <el-table-column v-slot="{ row }" min-width="80" label="金額" prop="total">
            <div class="Jost">${{ row.allActualPayTotal }}</div>
          </el-table-column>
          <el-table-column min-width="40">
            <el-tooltip content="查看訂單詳情" placement="top">
              <el-button type="text">
                <BaseIcon name="ellipsis-v" />
              </el-button>
            </el-tooltip>
          </el-table-column>
        </el-table>
      </div>
      <BasePagination ref="pagination" :current-page.sync="currentPage" />
    </div>

    <!-- 新增訂單 -->
    <el-drawer ref="orderForm" class="only-close" :class="{ 'appStyle': appStyle }" :visible.sync="createOrderVisible"
      :append-to-body="true" :size="$root.isSmallDevice ? '100%' : '90%'" destroy-on-close :modal-append-to-body="false"
      :wrapper-closable="false" custom-class="order-drawer">
      <DepositOrderForm order-type="deposit" @store="onCreateOrderDone" />

    </el-drawer>

    <!-- 編輯訂單 -->
    <el-drawer ref="orderFormEdit" class="only-close" :class="{ 'appStyle': appStyle }" :visible.sync="editOrderVisible"
      :append-to-body="true" :size="$root.isSmallDevice ? '100%' : '90%'" destroy-on-close :modal-append-to-body="false"
      :wrapper-closable="false" custom-class="order-drawer" order-type="deposit">
      <DepositOrderDetail order-type="deposit" :default-value.sync="drawerOrderData" @update="onEditOrderDone"
        @closeEditDrawer="closeEditDrawer" @updateDrawerData="updateDrawerData" />
    </el-drawer>
  </div>
</template>
<style lang="scss" module>
:global {
  :local(.filter) {
    &>div {

      // flex-wrap: wrap;
      .el-form-item {
        @include max-lg {
          width: 100% !important;
        }
      }

      &+button {
        align-self: baseline;
      }
    }
  }
}

.order-expanded {
  :global {
    .item {
      display: flex;
      align-items: center;
      padding: 20px;
      position: relative;
      align-items: flex-start;

      &.header {
        // background-color: #e2e2df;
        padding: 15px 20px;
      }

      &.header,
      &.no-divider {
        &:after {
          display: none;
        }
      }

      >div {
        flex: 1 1 auto;
        padding: 0 10px;

        &.vs-hide {
          visibility: hidden;
        }

        &.cancel {
          text-decoration: line-through;
          color: #919191;
        }

        &:first-child {
          padding-left: 0;
        }

        &:last-child {
          text-align: right;
          padding-right: 0;
        }

        &:nth-child(1) {
          width: 25%;
        }

        &:nth-child(2) {
          width: 20%;
        }

        &:nth-child(3) {
          width: 10%;
        }

        &:nth-child(4) {
          width: 10%;
        }

        &:nth-child(5) {
          width: 10%;
        }
      }

      &:after {
        content: '';
        position: absolute;
        border-bottom: 1px solid $color-border-base;
        bottom: 0;
        left: 0;
        right: 0;
        margin: 0 20px;
      }
    }

    .footer {
      text-align: right;
      padding: 20px;

      >div {
        line-height: 20px;
      }

      .total {
        color: $color-text-light;
        margin-bottom: 10px;
      }

      .unpaid {
        color: #e35d5d;
      }
    }
  }
}

.btnTop {
  padding: 0.5rem 0;

  @include max-sm {
    display: flex;
    flex-direction: column;
  }

  :global {
    .side {
      @include max-sm {
        display: flex;
        // flex-direction: column;
      }

      &:first-child {
        @include max-sm {
          margin-bottom: 0.5rem;

          .el-button {
            flex: 1 0 0;
            width: 50%;
          }
        }
      }

      .el-input {
        @include max-sm {
          margin-left: 0 !important;
          width: 100%;
        }
      }
    }
  }
}
</style>
